// use this as starting point and import your modules here
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import topnav from './partial/topnav';
import emailDeobfuscation from './utilities/email-deobfuscation';
import referenceTeasers from './partial/reference-teasers';
import stickyList from './utilities/sticky-list';
import threeDImages from './utilities/3d-images';
import parallax from './utilities/parallax';
import slider from './utilities/slider.js';
import textImageSlider from './modules/text-image-slider.js';
import references from './modules/references/references.js';
import video from './modules/video.js';
import smrObserver from './utilities/smr_observer.js';
import numbers from './modules/numbers.js';
import smrEventBus from './utilities/smr_event-bus.js';
import impressions from './modules/impressions.js';

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.expand = 400;

window.addEventListener(
  'load',
  () => {
    smrEventBus.init(); // globally accessible via window.smr_eventbus
    smrObserver.init(); // globally accessible via window.smr_observer
    topnav.init();
    emailDeobfuscation.init();
    impressions.init();
    referenceTeasers.init();
    stickyList.init();
    threeDImages.init();
    parallax.init();
    slider.init(Swiper, Navigation, Pagination);
    textImageSlider.init(Swiper, Navigation, Pagination);
    references.init();
    video.init();
    numbers.init();
  },
  false
);
